module.exports = __webpack_public_path__ + "img/Citatorio a Asamblea General 2024.9466f731.png";